import * as React from "react";
import { filter } from "graphql-anywhere";
import { makeStyles } from "@mui/styles";
import { fragments as productionJobLineItemBreakdownFragments } from "./components/ProductionJobLineItemBreakdown/graph";
import Card from "@mui/material/Card";
import ProductionJobLineItemBreakdown from "./components/ProductionJobLineItemBreakdown";
import Typography from "@mui/material/Typography";

const pluralize = require("pluralize");

const useStyles = makeStyles(theme => ({
  list: {
    listStyle: "none",
    margin: 0,
    padding: 0
  },
  item: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1)
  },
  titleWrapper: {
    marginBottom: theme.spacing(0.5)
  }
}));

const ProductQuantitySummary = ({
  productionJob: {
    lineItemBreakdownByProduct,
    productCount,
    totalProductVariantQuantity
  }
}) => {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.titleWrapper}>
        <Typography variant="h6" color="inherit">
          {`Associated products (${pluralize(
            "piece",
            totalProductVariantQuantity,
            true
          )} | ${pluralize("style", productCount, true)})`}
        </Typography>
      </div>
      <Card>
        <ul className={classes.list}>
          {lineItemBreakdownByProduct.map(productionJobLineItemBreakdown => (
            <li
              key={productionJobLineItemBreakdown.product.id}
              className={classes.item}
            >
              <ProductionJobLineItemBreakdown
                productionJobLineItemBreakdown={filter(
                  productionJobLineItemBreakdownFragments.productionJobLineItemBreakdown,
                  productionJobLineItemBreakdown
                )}
              />
            </li>
          ))}
        </ul>
      </Card>
    </div>
  );
};

export default ProductQuantitySummary;
